import React from 'react'
import { useTheme } from "@mui/material/styles";
const SkeletonOnboard = () => {
    const theme = useTheme();
    const logo = theme.custom?.logo || "/assets/img/logo/ur-biru.webp";
    
    return (
        <div
            style={{
                width: 300,
                height: "100vh",
                position: 'relative',
                overflow: 'hidden',
                display: "flex",
                alignItems: "center"
            }}
        >
            <img
                alt="ur"
                src={logo}
                style={{
                    borderRadius: 10,
                    width: 300,
                    height: 300,
                    objectFit: 'cover',
                    objectPosition: 'center',
                    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
                }}
            />
        </div>
    )
}

export default SkeletonOnboard